import request from '@/services/request'
import { getApiUrl } from '@/utils/tool'

export function getAllProductInfo(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/shop/product-list',
    method: 'post',
    data: object
  })
}

export function purchaseProd(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/shop/perchase',
    method: 'post',
    data: object
  })
}

export function prodStatus(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/shop/perchase-able',
    method: 'post',
    data: object
  })
}
